import _ from 'lodash'
import { BetsCycleLoader } from '@/components/ui/betscycle-loader'
import { cn } from '@/lib/utils'
import { BalanceListItem } from '@/components/profile/balance/BalanceListItem'
import type { PaymentBalance } from '@/types/payment'

interface BalanceListProps {
	balances: PaymentBalance[]
	isLoading?: boolean
	settingDefaultCurrencyCode?: string | null
	disablingCurrencyCode?: string | null
	onDeposit: (currencyCode: string) => void
	onSetDefaultBalance: (currencyCode: string) => void
	onDisableBalance: (currencyCode: string) => void
	className?: string
}

export function BalanceList({
	balances,
	isLoading,
	settingDefaultCurrencyCode,
	disablingCurrencyCode,
	onDeposit,
	onSetDefaultBalance,
	onDisableBalance,
	className,
}: BalanceListProps) {
	if (isLoading) {
		return (
			<div className={cn('flex min-h-[120px] items-center justify-center py-6', className)}>
				<BetsCycleLoader size={32} aria-label='Loading balances' />
			</div>
		)
	}

	if (_.isEmpty(balances)) {
		return <p className={cn('py-4 text-center text-sm text-muted-foreground', className)}>No balances available.</p>
	}

	return (
		<div className={cn('flex flex-col gap-3', className)}>
			{_.map(balances, (balance) => (
				<BalanceListItem
					key={balance.id}
					balance={balance}
					onDeposit={onDeposit}
					onSetDefaultBalance={onSetDefaultBalance}
					onDisableBalance={onDisableBalance}
					isSettingDefault={settingDefaultCurrencyCode?.toUpperCase() === balance.currency_code.toUpperCase()}
					isDisabling={disablingCurrencyCode?.toUpperCase() === balance.currency_code.toUpperCase()}
				/>
			))}
		</div>
	)
}
